import { Request } from '@/classes/Request'

export interface TransitCardRateLimitError {
  isRateLimit: true
  retryAfterSeconds: number
  resetAt: string | null
  failureReason: string
}

// POST /ajax/funding_sources/add_transit_card
export const transitCardData = async (payload: Object): Promise<void | string> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post('/ajax/funding_sources/add_transit_card', payload)
      .then(() => {
        resolve()
      })
      .catch(err => {
        const status = err?.response?.status
        const data = err?.response?.data
        if (status === 429 && data?.error_code === 'TRANSIT_RATE_LIMITED') {
          const rateLimitError: TransitCardRateLimitError = {
            isRateLimit: true,
            retryAfterSeconds: Number(data.retry_after_seconds ?? 0),
            resetAt: data.reset_at ?? null,
            failureReason: data.failure_reason ?? ''
          }
          reject(rateLimitError)
          return
        }
        reject('Failed to add transit card: ' + err)
      })
  })
}
